
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';
import GoldSectionDivider from '@/components/ui/gold-section-divider';

// Features data
const features = [
  {
    title: "Non-Destructive",
    description: "Preserves aesthetics of historic, ornamental, or functional fences."
  },
  {
    title: "Cost-Effective",
    description: "Quick deployment without rebuilding perimeters."
  },
  {
    title: "Alarms by Situation",
    description: "Automated alerts via app or central control room."
  }
];

const FenceFeatures = () => {
  return (
    <section className="section bg-boundri-background" aria-labelledby="why-choose-heading">
      <div className="container mx-auto">
        <div className="flex flex-col items-center mb-8">
          <GoldSectionDivider centered />
          <h2 id="why-choose-heading" className="text-center text-boundri-DEFAULT mb-2">
            Why Choose It?
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {features.map((item, index) => (
            <AnimateInView key={index} animation="scale-in" delay={200 * index}>
              <div className="p-6 border border-boundri-lavender/20 rounded-lg hover:shadow-md transition-shadow bg-white h-full">
                <h3 className="text-xl font-serif text-boundri-DEFAULT mb-3">{item.title}</h3>
                <p className="text-boundri-charcoal">
                  {item.description}
                </p>
              </div>
            </AnimateInView>
          ))}
        </div>
        <AnimateInView>
          <div className="text-center">
            <Button asChild className="text-white">
              <Link to="/contact">
                Discuss Your Requirements
              </Link>
            </Button>
          </div>
        </AnimateInView>
      </div>
    </section>
  );
};

export default FenceFeatures;
